import React from 'react'

const Bullet = () => {
    return (
        <span className="bullet">
            
        </span>
    )
}

export default Bullet
